import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDia3gbyEytcNSQ9dtsRHucvDvU4AKtePg',
  authDomain: 'universododireito-65814.firebaseapp.com',
  projectId: 'universododireito-65814',
  storageBucket: 'universododireito-65814.firebasestorage.app',
  messagingSenderId: '1044147609316',
  appId: '1:1044147609316:web:adf443cd053d5f8c0156f1',
  measurementId: 'G-GCXK50NL17'
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
